import Controller from '../abstracts/Controller';
import 'scss-templates/t-data-enrichment.scss';

export default class DataEnrichmentController extends Controller {
  static get COMPONENTS() {
    return [
      'CommonFormComponent',
      'CustomSelectComponent',
      'DatePickerComponent'
    ];
  }
}
